<template lang="pug">
div.box
    v-server-table(
        :url="api",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
        template(slot="beforeTable")
            datatable-loader(:name="tableName")

        template(slot="short_name" slot-scope="props")
            optional-cell-value(v-model="props.row.short_name")

    tax-form(ref="taxForm")

    add-products-form(v-if="openProduct" ref="addProductsForm" :tax-id="taxId")
    add-outlets-form(v-if="openProduct" ref="addOutletsForm" :tax-id="taxId")
    add-fuels-form(v-if="openFuel" ref="addFuelsForm" :tax-id="taxId")
    add-tags-form(v-if="openTag" ref="addTagsForm")
</template>

<script>
import Auth from '@js/plugins/auth';
import taxForm from './tax_form.vue';
import CollectionCounter from '@js/components/collection-counter';
import OptionalCellValue from '@js/components/optional-cell-value';
import addProductsForm from './add-products-form';
import addOutletsForm from './add-outlets-form';
import dateFormatMixin from '../../../mixins/date-format';
import addTagsForm from './add-tags-form';
import addFuelsForm from './add-fuels-form';

const TableName = 'VUETABLE_TAX';

export default {
    components: {
        taxForm,
        CollectionCounter,
        OptionalCellValue,
        addProductsForm,
        addOutletsForm,
        addTagsForm,
        addFuelsForm,
    },

    mixins: [dateFormatMixin],

    data() {
        var that = this;
        let canManageTaxes = Auth.hasPermissionTo('franchise_manage_taxes');

        let actionButtons = [
            {
                title: 'Create Tax',
                action: () => {
                    this.showForm(null);
                },
            },
        ];

        if (!canManageTaxes) {
            actionButtons = [];
        }

        return {
            openProduct: false,
            openOutlet: false,
            openFuel: false,
            openTag: false,
            taxId: null,
            tax: null,
            tableName: TableName,
            api: Laroute.route('franchise.inventory.tax.index'),

            columns: [
                'name',
                'short_name',
                'amount',
                // 'scope',
                'effective_at',
                'deactivate_at',
                // 'products',
                // 'fuels',
                // 'tags',
                'outlets',
                'status',
            ],

            options: {
                texts: {
                    title: 'Taxes',
                },
                checkbox: canManageTaxes,
                checkbox_actions: {
                    api_delete: Laroute.route('franchise.inventory.tax.delete'),
                    delete_title: 'Delete Taxes',
                },
                customFilters: ['outlet_id'],
                initFilters: {
                    outlet_id: that.$store.getters.activeOutlet,
                },
                sortable: ['name', 'short_name'],
                headings: {
                    short_name: 'Short Name',
                    effective_at: 'Effective At',
                    deactivate_at: 'Ineffective At',
                    outlets: 'Stations',
                },
                orderBy: { column: 'name', ascending: 1 },
                csv_url: Laroute.route('franchise.inventory.tax.exportAsFile', {
                    type: 'CSV',
                }),
                pdf_url: Laroute.route('franchise.inventory.tax.exportAsFile', {
                    type: 'PDF',
                }),
                actionButtons: actionButtons,
                rowClassCallback: row => {
                    let clazz = ['pointer'];

                    if (row.status == 0) {
                        clazz.push('text-muted');
                    }

                    return clazz;
                },
                rowClickCallback: row => that.showForm(row.id),
                templates: {
                    amount(h, row) {
                        return require('./amount.jsx')(h, row);
                    },
                    // scope: (h, row) => {
                    //     if (row.scope === 'LINE_ITEM') {
                    //         return 'Line Item';
                    //     }
                    //
                    //     return 'Order';
                    // },
                    effective_at: (h, row) => {
                        if (row.effective_at) {
                            return this.dateOnly(row.effective_at);
                        }
                    },
                    deactivate_at: (h, row) => {
                        if (row.deactivate_at) {
                            return this.dateOnly(row.deactivate_at);
                        }
                    },
                    // products: (h, row) => {
                    //     return require('../charge/assigned-count')(
                    //         h,
                    //         row,
                    //         row.products_count,
                    //         'products',
                    //     );
                    // },
                    // fuels: (h, row) => {
                    //     return require('../charge/assigned-count')(
                    //         h,
                    //         row,
                    //         row.fuels_count,
                    //         'fuels',
                    //     );
                    // },
                    // tags: (h, row) => {
                    //     return require('../charge/assigned-count')(
                    //         h,
                    //         row,
                    //         row.tags_count,
                    //         'tags',
                    //     );
                    // },
                    outlets: (h, row) => {
                        return require('../charge/assigned-count')(
                            h,
                            row,
                            row.outlets_count,
                            'stations',
                        );
                    },
                    status: (h, row) => {
                        return require('../charge/status')(h, row);
                    },
                },
            },
        };
    },
    computed: {
        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },
    },

    watch: {
        activeOutlet: function() {
            this.$store.commit(`${TableName}/SET_CUSTOM_FILTER`, {
                filter: 'outlet_id',
                value: this.activeOutlet,
            });
        },
    },

    mounted() {
        this.$refs.taxForm.$on('tax-saved', () => {
            this.$refs.datatable.getData();
        });
    },

    methods: {
        async showForm(id) {
            this.closeComponent();

            this.taxId = id;

            await this.emitShowForm(id).then(r => {
                this.openComponent();
            });
        },

        async emitShowForm(id) {
            this.$refs.taxForm.$emit('show-form', id);
        },

        closeComponent() {
            this.openProduct = false;
            this.openOutlet = false;
            this.openFuel = false;
            this.openTag = false;
        },

        openComponent() {
            this.openProduct = true;
            this.openOutlet = true;
            this.openFuel = true;
            this.openTag = true;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/tax/vuetable_tax.vue